<script>
export default {
  name: "LeFootah"
}
</script>

<template>
<div class="le-footah">
  <div class="le-footah-bg"></div>
  <div class="le-footah-content">
    <div class="le-footah-group le-footah-logo">
      <img src="@/assets/FooterLogo.svg" alt="Vidolia">
    </div>

    <div class="le-footah-group">
      <span class="le-footah-caption">
        Контакты
      </span>

      <a class="le-footah-link" href="https://t.me/vidolia">
        <i class="fa-brands fa-discord"></i>

        Discord
      </a>

      <!-- YouTube -->
      <a class="le-footah-link" href="https://www.youtube.com/@Vidolia">
        <i class="fa-brands fa-youtube"></i>

        YouTube
      </a>

      <!-- mail -->
      <a class="le-footah-link" href="mailto:JtLZG@example.com">
        <i class="fa-solid fa-envelope"></i>

        JtLZG@example.com
      </a>
    </div>

    <div class="le-footah-group">
      <span class="le-footah-caption">
        Для пользователей
      </span>

      <a class="le-footah-link" href="https://t.me/vidolia">
        Политика конфиденциальности
      </a>

      <a class="le-footah-link" href="https://t.me/vidolia">
        Договор оферты
      </a>
    </div>

    <div class="le-footah-group">

    </div>
  </div>
</div>
</template>

<style lang="sass">
.le-footah
  padding: 31px
  margin-top: calc(-240px)
  position: relative

  &-bg
    position: absolute
    background: rgba(73, 73, 73, 0.06)
    background-blend-mode: soft-light
    filter: blur(50px)
    backdrop-filter: blur(25px)
    left: 0
    top: 0
    width: 100%
    height: 100%

  .le-footah-content
    background-blend-mode: normal
    display: flex
    //justify-content: space-between
    vertical-align: top
    padding: 20px 0
    margin: 0 100px 0 100px
    z-index: 999
    backdrop-filter: blur(1px)
    background: rgba(73, 73, 73, 0.06)
    .le-footah-logo
      img
        //margin: auto

    .le-footah-group
      display: flex
      flex-direction: column
      gap: 10px
      margin: 0 auto 0 auto
      text-align: left
      text-decoration: none


      .le-footah-caption
        font-family: Inter, serif
        font-size: 18px
        margin-bottom: 20px

        color: #FFF

      .le-footah-link
        display: flex
        align-items: center
        gap: 10px
        font-family: Inter, serif
        font-size: 14px
        text-decoration: none
        color: #FFF
        opacity: 0.5

        &:hover
          opacity: 1


        i
          font-size: 16px
          width: 16px
</style>